/* eslint-disable */
export default {
  header: 'Fehlerverfolgung deaktivieren',
  content:
    'Durch Deaktivieren des Fehlerverfolgungsmodus werden alle aktuellen Fehlerprotokolle gelöscht. Möchten Sie fortfahren?',
  confirm: 'Deaktivieren',
  cancel: 'Abbrechen',
} as const;

// @key: @#@"header"@#@ @source: @#@"Turn off error tracking"@#@
// @key: @#@"content"@#@ @source: @#@"Turning off error tracking mode will delete any current error logs. Do you wish to continue?"@#@
// @key: @#@"confirm"@#@ @source: @#@"Turn off"@#@
// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
